const dimensions = {
    inputPadding: '16px 8px',
    layoutWidth: '90%',
    loginLayoutWidth: '248px',
    hintFontSize: '0.7rem',
    hamburgerSize: '1.5rem',
    sidebarFontSize: '18px'
};
export default dimensions;
